export default function Alert({ type = 'info', children }) {
  const baseStyle = {
    width: '100%',
    maxWidth: '400px',
    margin: '0 auto 1rem auto',
    padding: '10px 14px',
    borderRadius: '8px',
    textAlign: 'center',
    fontWeight: 'bold',
    border: '1px solid',
  }

  const typeStyles = {
    warning: {
      color: '#ff4d4f',
      backgroundColor: 'rgba(255, 77, 79, 0.1)',
      borderColor: '#ff4d4f',
    },
    error: {
      color: '#ff4d4f',
      backgroundColor: 'rgba(255, 77, 79, 0.15)',
      borderColor: '#ff4d4f',
    },
    info: {
      color: '#ccc',
      backgroundColor: '#1a1a1a',
      borderColor: '#555',
      fontWeight: 'normal',
    },
  }

  return <div style={{ ...baseStyle, ...typeStyles[type] }}>{children}</div>
}
